<template>
  <div id="foot">
    <div class="foot_con">
      <div class="wrap wrap1">
        <div class="list">
          <span>{{$t('footer').keyaddress}}</span>
          <p>{{$t('footer').address}}</p>
        </div>
      </div>
      <div class="wrap wrap2">
        <div class="list">
          <span>{{$t('footer').keyphone}}</span>
          <p>{{$t('footer').tel}}</p>
        </div>
        <div class="list">
          <span>{{$t('footer').keyWebsite}}</span>
          <p>
            <a href="http://www.cimdr.com">www.cimdr.com</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <a href="http://www.ccfdie.org">www.ccfdie.org</a>
          </p>
        </div>
      </div>
      <div class="wrap wrap3">
        <div class="list">
          <span>{{$t('footer').keyfax}}</span>
          <p>{{$t('footer').fax}}</p>
        </div>
        <div class="list">
          <span>{{$t('footer').keyzipcode}}</span>vs
          <p>{{$t('footer').code}}</p>
        </div>
      </div>


    </div>
    <div class='public'>
 <p style='margin-top:10px'> <span style="margin-right:10px">{{$t('footer').public}}</span><a href="https://beian.miit.gov.cn">{{$t('footer').record}}</a></p>

      <div style="height: 20px;">
        <img src="./img/logo.png" style="vertical-align:middle">
        <p style="display: inline-block">{{$t('footer').technicalSupport}}</p>
      </div>
    </div>

  </div>
</template>
<script type="text/ecmascript-6">
export default {
  data() {
    return {};
  },
  props: {},
  methods: {},
  computed: {},
  mounted() {}
};
</script>
<style type="text/scss" lang="scss" scoped>
#foot {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  line-height: 30px;
  background: #F2F2F2;
  font-size: 14px;
  padding: 20px 0;
  color: #666;
  .foot_con {
    width: 1000px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    .wrap {
      float: left;
      width: 300px;
      .list {
        overflow: hidden;
        span {
          float: left;
        }
        p {
          float: left;
        }
      }
    }
    .wrap1 {
      width: 400px;

      .list {
        p {
          text-align: left;
          width:300px;
        }
      }
    }
    .wrap3 {
      width: 200px;
     float: right;
    }
  }
  .public {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home/HomeFoot.vue